/* eslint-disable no-case-declarations */
const INITIAL_STATE = {
  gtosList: [],
  loading: false,
  glosaCount: 0
};

export default (state = INITIAL_STATE, action) => {
  if(!action){
    return state;
  }
  switch (action.type) {
    case 'gto/LOADING':
      return { ...state, loading: true };

    case 'gto/UNLOADING':
      return { ...state, loading: false };

    case 'gto/FETCH_DATA':
      return action.payload;

    case 'gto/CREATE':
      return [...state, action.payload.procedure.hash];

    default:
      return state;
  }
  
};
